import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
// logic
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import { useTranslation } from 'react-i18next';
// components
import SoFormPanel from 'refactored/features/soForm/components/layout/SoFormPanel';
import SoFormRowContainer from 'refactored/features/soForm/components/layout/SoFormRowContainer';
import SoFormPanelText from 'refactored/features/soForm/components/layout/SoFormPanelText';
import { GirdedQuestionIcon } from 'refactored/ui/icons';
import SoFormCheckboxInput from './SoFormCheckboxInput';
import Tag from 'components/Tag';
import Tooltip from 'components/Tooltip';

const TempContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const SoFormVehicleDetails = ({ className }) => {
  const { t: catalogT } = useTranslation('Catalog');

  const countrySettings = useSelector(settingsSelectors.getCountrySettings);

  const isFrance = countrySettings.country === 'FR';

  const options = [
    {
      label: catalogT('configuration.vehicle_details.side_load'),
      extraName: 'SIDE_LOAD',
    },
    {
      label: catalogT('configuration.vehicle_details.top_load'),
      extraName: 'TOP_LOAD',
    },
    {
      label: catalogT('configuration.vehicle_details.liftgate'),
      extraName: 'LIFTGATE',
    },
  ];

  let notAvailableOptionsExtranames = [];
  if (isFrance) notAvailableOptionsExtranames.push('TOP_LOAD');
  const availableOptions = options.filter(
    (i) => !notAvailableOptionsExtranames.includes(i.extraName)
  );

  const { t } = useTranslation('VehicleExtras');

  return (
    <div className={className}>
      <SoFormPanel>
        <SoFormRowContainer>
          <SoFormPanelText>
            {catalogT('configuration.vehicle_details.header')}
            <Tag label={catalogT('configuration.vehicle_details.optional')} />
          </SoFormPanelText>
          <Tooltip
            className="title-tooltip"
            component={t(`directHelper`)}
            segmentTitle="form configuration_vehicle_details"
          >
            <GirdedQuestionIcon />
          </Tooltip>
        </SoFormRowContainer>
        <TempContainer>
          {availableOptions.map((inputData) => (
            <SoFormCheckboxInput
              inputData={inputData}
              key={inputData.extraName}
            />
          ))}
        </TempContainer>
      </SoFormPanel>
    </div>
  );
};

SoFormVehicleDetails.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export default styled(SoFormVehicleDetails)`
  ${regularCSS}
`;
